/**
 * @generated SignedSource<<e8bfff6ea42616f24b1f0fb704d037be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowWithDragAndDrop_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_project">;
  readonly " $fragmentType": "row_nativeIssueTable_RowWithDragAndDrop_project";
};
export type row_nativeIssueTable_RowWithDragAndDrop_project$key = {
  readonly " $data"?: row_nativeIssueTable_RowWithDragAndDrop_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowWithDragAndDrop_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowWithDragAndDrop_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "row_nativeIssueTable_RowInner_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e305c96733bb25d26cbca91f49c03317";

export default node;
